import Typography from "@mui/joy/Typography";

type Props = {
    fontSize?: string|{ sm?: string, xs?: string, md?: string, lg?: string}
}

export default function DayOneLogo({fontSize}:Props) {
    if (fontSize === undefined) {
        fontSize = "75pt";
    }
    return (
        <Typography level="h1"
                        sx={{
                            fontFamily: "'Oranienbaum', serif",
                            fontSize: fontSize,
                            lineHeight: 1,
                        }}
        >Day Ones</Typography>
    );
}
